import { Link, useLocation, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { withInvestorQuery, getInvestorQueryParams } from "../../utils/investorRouteHelpers";

const TabBar = styled.nav`
  margin-bottom: 1.75rem;
`;

const TabList = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem;
  background: #ececec;
  border-radius: 14px;
  border: 1px solid #e0e0e0;
  max-width: 100%;
  overflow-x: auto;

  @media (max-width: 480px) {
    display: flex;
    width: 100%;
  }
`;

const TabLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1rem;
  border-radius: 11px;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  color: #525252;
  background: transparent;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    color: #383838;
    background: rgba(255, 255, 255, 0.55);
  }

  &[aria-current="page"] {
    color: #383838;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 480px) {
    flex: 1;
    font-size: 0.78rem;
    padding: 0.6rem 0.5rem;
  }
`;

const TABS = [
  { id: "account", label: "Account" },
  { id: "verification", label: "Identity verification" },
  { id: "activity", label: "My activity" },
];

function buildTabHref(tabId, searchParams) {
  const query = getInvestorQueryParams(searchParams);
  return withInvestorQuery("/invest/profile", { ...query, tab: tabId });
}

export default function InvestorProfileNav() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  if (!pathname.startsWith("/invest/profile")) return null;

  const activeTab = searchParams.get("tab") || "account";

  return (
    <TabBar aria-label="Profile sections" data-tour="investor-profile-tabs">
      <TabList role="tablist">
        {TABS.map((tab) => (
          <TabLink
            key={tab.id}
            to={buildTabHref(tab.id, searchParams)}
            role="tab"
            aria-current={activeTab === tab.id ? "page" : undefined}
            data-tour={tab.id === "verification" ? "investor-profile-kyc" : undefined}
          >
            {tab.label}
          </TabLink>
        ))}
      </TabList>
    </TabBar>
  );
}

export function getProfileTab(searchParams) {
  const tab = searchParams?.get?.("tab") || searchParams?.tab || "account";
  if (["account", "verification", "activity"].includes(tab)) return tab;
  return "account";
}
